import { defineMessages } from "react-intl";
const emptyActionsSection = {
    formTemplateSectionId: "actions_section",
    fields: []
};
const createEmptyActionsPanel = (name) => ({
    formPanelId: name,
    sections: []
});
const ensureActionExists = (role, actions, append, fieldOptions, fieldPredicate) => {
    const defaultAction = {
        formTemplateFieldId: `${role}_button`,
        name: `${role}_button`,
        namespace: "default_actions",
        label: "",
        renderAs: "ButtonField",
        alwaysVisible: true,
        role,
        width: "auto",
        alignWithPrevious: true,
        variant: "contained",
        margin: "none",
        ...fieldOptions
    };
    const actionSections = actions.sections || [];
    const innerFieldPredicate = fieldPredicate ?? (f => f.role === role);
    if (!actionSections.some(s => s.fields.some(innerFieldPredicate))) {
        const [section = emptyActionsSection, ...rest] = append
            ? actionSections.reverse()
            : actionSections;
        const fields = append
            ? [...section.fields, defaultAction]
            : [defaultAction, ...section.fields];
        const sectionWithAction = {
            ...section,
            fields
        };
        const sectionsWithActions = [sectionWithAction, ...rest];
        return {
            ...actions,
            sections: append ? sectionsWithActions.reverse() : sectionsWithActions
        };
    }
    return actions;
};
const emptyActionsPanel = createEmptyActionsPanel("actions");
export const ensureActions = (intl, { step, isLastStep }, actions = emptyActionsPanel, canSubmit, prevLabel, nextLabel, submitLabel) => {
    if (step > 0) {
        actions = ensureActionExists("navigate_before", actions, false, {
            label: prevLabel ?? intl.formatMessage(messages.before)
        });
    }
    if (!isLastStep) {
        actions = ensureActionExists("navigate_next", actions, true, {
            color: "secondary",
            label: nextLabel ?? intl.formatMessage(messages.next)
        });
    }
    else if (canSubmit) {
        actions = ensureActionExists("submit", actions, true, {
            label: submitLabel ?? intl.formatMessage(messages.submit),
            color: "secondary",
            click: {
                namespace: "Main",
                service: "Submit"
            },
            renderAs: "SubmitButton"
        }, 
        // Skip fields already with submit role or SubmitButton as renderAs
        f => f.role === "submit" || f.renderAs === "SubmitButton");
    }
    return actions;
};
const emptyAppActionsPanel = createEmptyActionsPanel("appActions");
export const ensureAppActions = (intl, { isLastStep }, appActions = emptyAppActionsPanel) => {
    if (isLastStep) {
        appActions = ensureActionExists("appActions", appActions, false, {
            width: "auto",
            label: intl.formatMessage(messages.moreOptions),
            variant: "contained"
        });
    }
    return appActions;
};
const messages = defineMessages({
    next: {
        id: "dealer.applications.actions.nextButton.label",
        description: "Default label for next button",
        defaultMessage: "Next"
    },
    before: {
        id: "dealer.applications.actions.beforeButton.label",
        description: "Default label for before button",
        defaultMessage: "Back"
    },
    submit: {
        id: "dealer.applications.actions.submitButton.label",
        description: "Default label for submit button",
        defaultMessage: "Submit application"
    },
    moreOptions: {
        id: "dealer.applications.actions.moreOptions.label",
        description: "Default label for more options button",
        defaultMessage: "Options"
    }
});
//# sourceMappingURL=defaultActions.js.map